import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

const Report = () => {
    const { t } = useTranslation();
    return (
        <MainLayout
            title={t('employee-registration-report')}
            breadcrumb={[
                { title: t("home.header"), link: "/" },
                { title: t('report.header'), link: "/report" },
                { title: t('employee-history-group'), link: "/employee_history_group" },
            ]}>
            <Outlet />
        </MainLayout>
    );
}

export default Report;
